import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import IncPageHeader from 'components/inc-page/inc-page-header/inc-page-header.component';
import IncPageTabPanels from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.component';
import { IncPageTabPanelsProvider } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.context';
import IncPageTitle from 'components/inc-page/inc-page-title/inc-page-title.component';
import IncPage from 'components/inc-page/inc-page.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MenusLanding = () => {
  const { t } = useTranslation();

  const tabs = useMemo(
    () => [
      {
        label: t('page.menus.menus.tabs.imported'),
        path: 'imported',
      },
      {
        label: t('page.menus.menus.tabs.native'),
        path: 'native',
      },
    ],
    [t],
  );

  return (
    <IncPage>
      <IncPageHeader>
        <IncPageTitle />
      </IncPageHeader>

      <IncPageBody>
        <IncPageTabPanelsProvider tabs={tabs}>
          <IncPageTabPanels />
        </IncPageTabPanelsProvider>
      </IncPageBody>
    </IncPage>
  );
};

export default MenusLanding;
